module.exports = __webpack_public_path__ + "media/images/user/mic_icon-7061cdb632f40d0b5e51143f11e0b018.png";